import Link from "next/link";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "@@/styles/components/header/mobile/MobileNavigation.module.scss";
import navItemStyle from "@@/styles/components/header/mobile/MobileNavItem.module.scss";

import { HEADER_CATEGORY } from "../Header";

import { useHeaderCategoryContext } from "@@/hooks/contexts/headerCategroyContext";

import LanguageSwitch from "@@/components/header/LanguageSwitch";
import MobileNavItem from "@@/components/header/mobile/MobileNavItem";
import {usePathname} from "next/navigation";
import {JSX} from "react";
import Button from "@@/components/ui/Button";

interface IMobileNavigationProps {
	open: boolean
	onClose:CallableFunction
}

export default function MobileNavigation(props: IMobileNavigationProps): JSX.Element {

	const pathname = usePathname();

	useEffect(() => {
		onClose();
		setHoveredCategory(undefined);
	}, [pathname]);

	const { open, onClose, } = props;
	const { t, } = useTranslation();

	const [init, setInit] = useState<boolean>(true);
	const [animation, setAnimation] = useState<string>("");

	const { hoveredCategory, setHoveredCategory, } = useHeaderCategoryContext();

	const currentPathname = usePathname();


	useEffect(() => {
		setAnimation(() => {
			if (open) {
				return styles.slide_in;
			} else {
				if (init) {
					setInit(false);
					return "";
				}

				return styles.slide_out;
			}
		});

		if (open) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "unset";
		}
		const pageArray = currentPathname.split("/");
		const page = pageArray.slice(-1)[0];
	}, [open, currentPathname]);

	function closeHandler() {
		onClose();
	}

	function toggleHandler(category: HEADER_CATEGORY) {
		setHoveredCategory(category);
	}

	return (
		<>
			<div className={`${styles.main} ${animation} d-flex flex-column gap-1`}>
				<Link href="/"
					  className={`${navItemStyle.main} ${currentPathname === "/" ? navItemStyle.active : ""}`}
					  onClick={closeHandler}>
					<p>{t("home")}</p>
				</Link>
				<Link href="/about"
					  className={`${navItemStyle.main} ${currentPathname === "/about" ? navItemStyle.active : ""}`}
					  onClick={closeHandler}>
					<p>{t("aboutus")}</p>
				</Link>
				<Link href="/developpement_&_consultance"
					  className={`${navItemStyle.main} ${currentPathname === "/developpement_&_consultance" ? navItemStyle.active : ""}`}
					  onClick={closeHandler}>
					<p>{t("dev&cons")}</p>
				</Link>
				<Link href="/services"
					  className={`${navItemStyle.main} ${currentPathname === "/services" ? navItemStyle.active : ""}`}
					  onClick={closeHandler}>
					<p>{t("services")}</p>
				</Link>
				<MobileNavItem
					title={t("solutions")}
					category={HEADER_CATEGORY.SOLUTIONS}
					onClick={toggleHandler}
					onNavigate={closeHandler}
					toggled={hoveredCategory === HEADER_CATEGORY.SOLUTIONS}
				/>
				<MobileNavItem
					title={t("sectors")}
					category={HEADER_CATEGORY.SECTORS}
					onClick={toggleHandler}
					onNavigate={closeHandler}
					toggled={hoveredCategory === HEADER_CATEGORY.SECTORS}
				/>
				{/* <Link href="/" target="_blank" className={navItemStyle.main}>
					<p>{t("realisations")}</p>
				</Link>
				<Link href="/" target="_blank" className={navItemStyle.main}>
					<p>{t("integration")}</p>
				</Link> */}
				<Button href={`/contact`} title={t("contact")} textColor={`var(--blue-800)`} bgColor={`var(--blue-300)`} className={`p-1 px-2 w-100`} linkClassName={`mt-5`}></Button>

				<LanguageSwitch />
			</div>
		</>
	);
}
